const white = "#FFFFFF";
const black = "#000000";

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: "#0066A6",
    main: "#008FE8",
    light: "#72B9E6",
  },
  secondary: {
    contrastText: white,
    dark: "#C00400",
    main: "#FF2C28",
    light: "#F28886",
  },
  grey: {
    100: "#F5F5F5",
    200: "#CBCACA",
    300: "#999999",
    400: "#707070",
    500: "#7F7F80",
    600: "#585858",
    700: "#282828",
    800: "#3A3A3A",
    900: "#000000",
  },
  text: {
    primary: black,
    secondary: "#6C7078",
    link: "#447AFF",
  },
  background: {
    default: white,
    paper: white,
  },
  divider: "#E6E8EB",
};
